import { inject, Injectable } from '@angular/core';
import { type CanDeactivateFn } from '@angular/router';
import { FormChangesModalsService } from '@modules/common/services/form-changes-modals.service';
import { finalize, type Observable, shareReplay, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotesNavigationConfirmationService {
  private readonly forms = inject(FormChangesModalsService);
  private pending: Observable<boolean> | undefined;

  public confirm(): Observable<boolean> {
    this.pending ??= this.forms.confirmUnsavedChanges().pipe(
      take(1),
      finalize(() => {
        this.pending = undefined;
      }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );
    return this.pending;
  }
}

export const notesWorkspaceCanDeactivate: CanDeactivateFn<unknown> = () =>
  inject(NotesNavigationConfirmationService).confirm();
